import React from 'react';
import { Route } from 'react-router';

function PrivateRoute(props: any) {
  const { component: Component, roles, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(props: any) => {
        return <Component {...props} />;
      }}
    />
  );
}

export default PrivateRoute;
